/**
 * AiBomSettings – Print & PDF section-visibility toggles for the AI-BOM page.
 *
 * @param values        - current PrintSettings boolean map (key → visible)
 * @param onToggle      - handler for individual key toggle
 * @param onToggleAll   - handler to flip all items at once
 */

import { useState } from 'react';
import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { SettingsDialog, type SettingsItem } from './SettingsDialog';

const ITEMS: SettingsItem[] = [
  { key: 'showHeader', label: 'Header & Title' },
  { key: 'showSummaryCards', label: 'Summary Cards' },
  { key: 'showAlertBanner', label: 'Alert Banner' },
  { key: 'showLLMComponents', label: 'LLM Components' },
  { key: 'showAPIComponents', label: 'API Components' },
  { key: 'showLibraries', label: 'Libraries' },
  { key: 'showVulnerabilities', label: 'Vulnerability Details' },
  { key: 'showLicenseDetails', label: 'License Details' },
  { key: 'showSystemTools', label: 'System Tools' },
];

interface AiBomSettingsProps {
  values: Record<string, boolean>;
  onToggle: (key: string) => void;
  onToggleAll: () => void;
}

export function AiBomSettings({ values, onToggle, onToggleAll }: AiBomSettingsProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outline" size="sm" className="gap-2" onClick={() => setOpen(true)}>
        <Settings className="w-4 h-4" />
        Settings
      </Button>
      <SettingsDialog
        title="Print & PDF Settings"
        description="Customize which sections appear when printing or saving as PDF"
        open={open}
        onOpenChange={setOpen}
        items={ITEMS}
        values={values}
        onToggle={onToggle}
        onToggleAll={onToggleAll}
      />
    </>
  );
}
